module.exports = "/images/file-preview-icon.svg?2ede8e4654979d33e12d868b533a36a8";